<template>
  <Modal v-model="model" :title="title" sticky reset-drag-position  @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="message_template_pop Internal_call" width="800">
    <div class="input_single">
      <div class="font_style_set"><span style="color: #ed4014">*</span>{{inputName}}:</div>
      <Input v-model="number" class="input_content" clearable/>
    </div>
    <div class="fixed_table" v-if="showTable">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table style="width: 100%" class="element_table" stripe ref="selection" @cell-click="handleCurrentChange" :data="infoTableList.filter(data => !number || data.number.toLowerCase().includes(number.toLowerCase()))">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed"  :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
      </el-table>
    </div>
    <div class="fixed_table" v-if="showmail">
      <Spin size="large" fix v-if="spinShowmail"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table style="width: 100%" class="element_table" stripe ref="selection" @cell-click="mailCurrentChange" :data="contentList.filter(data => !number || data.telephone.toLowerCase().includes(number.toLowerCase())|| data.userName.toLowerCase().includes(number.toLowerCase())||data.note.toLowerCase().includes(number.toLowerCase()))">
        <el-table-column v-for="(item,index) in mailfieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed"  :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
      </el-table>
    </div>
    <div class="btn_template" style="width: 100%;">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="transfer()">确定</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: "TransferPage",
    props: {
      showTransfer:Boolean,
      transferType:String,
    },
    data(){
      return {
        model:false,
        number:'',
        selection:'',
        inputName:'座席号码',
        spinShow:true,
        spinShowmail:true,
        tableClass: true,
        title:'转接座席',
        infoTableList:[],
        fieldList:[],
        contentList: [],
        mailfieldList: [
          {key: "userName", title: "姓名" },
          { key: "telephone", title: "号码" },
          { key: "note", title: "备注" },
        ],
        
        showTable:false,
        showmail:false,
        ivrId:'',
      }
    },
    methods:{
      handleCurrentChange(val) {
        this.number = val.number;
        if(this.transferType=="ivr"){
          this.ivrId= val.id;
        }
      },
      mailCurrentChange(val) {
        this.number = val.telephone;
      },
      cancel:function(){
        document.onkeydown = undefined;
        this.$emit("closeTransferPage",'cancel');
      },
      transfer:function () {
        let number=this.number;
        if(this.transferType=="ivr"){
          number=this.ivrId;
        }
        if(this.transferType!="ivr"){
          if(!number){
            this.$Message.info("号码不能为空");
            return false;
          }
          let reg=/[0-9\*\#]/gi;
          if(!reg.test(number)){
            this.$Message.info("号码格式错误,请重新输入");
            return false;
          }
        }
        document.onkeydown = undefined;
        this.$emit("closeTransferPage",this.transferType,number);
      },
      initSearchAgent:function(){
        this.spinShow=true;
        let that=this;
        let param={
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("popUp/getInternalCall.json",param) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          that.infoTableList=[];
          let list=res.data.obj;
          for (let i=0;i<list.length;i++){
            let param={
              status:list[i].employeeOnLineState,
              name:list[i].employeeName,
              number:list[i].agentNumber
            };
            that.infoTableList.push(param);
          }
        });
      },
      initSearchSkill:function () {
        this.spinShow=true;
        let that=this;
        let param={
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("skillGroup/toIndex.json",param) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.infoTableList=[];
          let list=res.data.obj.list.content;
          for (let i=0;i<list.length;i++){
            let param={
              createTime:list[i].createTime,
              name:list[i].queueName,
              number:list[i].queuePhone
            };
            that.infoTableList.push(param);
          }
        });
      },
      initSearchIVR:function () {
        this.spinShow=true;
        let that=this;
        let param={
          journalType:"null",
          menuId:"null",
          pageNum:"0",
          pageSize:"0"
        };
        this.$http.post("ivr/selectIvrs.json",param) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.infoTableList=[];
          let list=res.data.obj.content;
          for (let i=0;i<list.length;i++){
            let param={
              number:list[i].ivrName,
              id:list[i].id
            };
            that.infoTableList.push(param);
          }
        });
      },
      initSearchmail:function () {
        let that=this;
        let param={
          journalType:"null",
          menuId:"null"
        };
        this.spinShowmail=true;
        this.$http.post("externalAddressBook/toIndex.json",param) .then(function (res) {
          let result=res.data;
          that.spinShowmail=false;
          if(result.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.contentList=res.data.obj.list.content;
        })
      }


    },
    watch:{
      showTransfer:function () {
        this.model=this.showTransfer;
        this.number="";
        this.ivrId="";
        let that = this;
        this.showTable=false;
        this.showmail=false;
        if(!this.showTransfer){
          document.onkeydown = undefined;
        }
        if(this.showTransfer){
          this.infoTableList=[];
          this.fieldList=[];
          document.onkeydown = function(){
            let key = window.event.keyCode;
            if(key === 13){
              that.transfer()
            }
          };
          if(this.transferType=="agent"){
            this.title="转接座席";
            this.inputName="座席号码";
            this.fieldList=[{key:'name','title':'员工姓名'}, {key:'number','title':'座席号码'},{key:'status','title':'在线状态'}];
            this.showTable=true;
            this.initSearchAgent();
          }
          if(this.transferType=="queue"){
            this.title="转接技能组";
            this.inputName="技能组号码";
            this.fieldList=[{key:'name','title':'技能组名称'},{key:'number','title':'技能组号码'},{key:'createTime','title':'创建时间'}];
            this.showTable=true;
            this.initSearchSkill();
          }
          if(this.transferType=="ivr"){
            this.title="转接IVR";
            this.inputName="IVR名称";
            this.fieldList=[{key:'number','title':'IVR名称'}];
            this.showTable=true;
            this.initSearchIVR();
          }
          if(this.transferType=="pstn"){
            this.title="转接外线";
            this.inputName="外线号码";
            this.showmail=true;
            this.initSearchmail();
          }
          if(this.transferType=="askAgent"){
            this.title="询问座席";
            this.inputName="座席号码";
            this.fieldList=[{key:'name','title':'员工姓名'},{key:'number','title':'座席号码'},{key:'status','title':'在线状态'}];
            this.showTable=true;
            this.initSearchAgent();
          }
          if(this.transferType=="askPstn"){
            this.title="询问外线";
            this.inputName="外线号码";
            this.showmail=true;
            this.initSearchmail();
          }
          if(this.transferType=="askTransfer"){
            this.title="确定询问";
          }
          if(this.transferType=="cancelAsk"){
            this.title="取消询问";
          }
          if(this.transferType=="threeway"){
            this.title="三方座席";
            this.inputName="座席号码";
            this.fieldList=[{key:'name','title':'员工姓名'}, {key:'number','title':'座席号码'},{key:'status','title':'在线状态'}];
            this.showTable=true;
            this.initSearchAgent();
          }
          if(this.transferType=="threewayPstn"){
            this.title="三方外线";
            this.inputName="外线号码";
          }
          if(this.transferType=="cancelThreeway"){
            this.title="取消三方";
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/loginHeadMange/TransferPage.vue